import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { ArrowRight, Code, Lightbulb, Rocket } from 'react-bootstrap-icons';
import { useNavigate  } from 'react-router-dom';
import './PageCss/HomePage.css';

// Import images
import img111 from '../img/tech1.jpg';
import img112 from '../img/tech2.jpg';
import img1 from '../img/tech3.jpg';
import img1900_1 from '../img/feature1.jpg';
import img1900_2 from '../img/feature2.jpg';
import img1900_3 from '../img/feature3.jpg';

const slides = [
  {
    id: 1,
    background: img111,
    title: 'Welcome to TechShara',
    subtitle: 'Your Ultimate Destination for Tech Insights, Tutorials, and Innovation',
    buttonText: 'Explore Articles',
    feature: img1900_1
  },
  {
    id: 2,
    background: img112,
    title: 'Learn & Grow',
    subtitle: 'Master the Latest Technologies with Our Expert Tutorials',
    buttonText: 'Start Learning',
    feature: img1900_2
  },
  {
    id: 3,
    background: img1,
    title: 'Join Our Community',
    subtitle: 'Connect with Fellow Developers and Share Your Knowledge',
    buttonText: 'Get Started',
    feature: img1900_3
  }
];


const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [bgLoaded, setBgLoaded] = useState(false);
  useEffect(() => {
    // Preload background image for smooth transition
    const img = new Image();
    img.src = slides[currentSlide].background;
    img.onload = () => setBgLoaded(true);
  }, [currentSlide, slides]);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, []);
  const navigate = useNavigate();
  return (
    <div className="home-page">
     <section className="hero-section">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''} ${bgLoaded ? 'loaded' : 'loading'}`}
            style={{ backgroundImage: `url(${slide.background})` }}
          />
        ))}
        <div className="hero-overlay" />

        <Container>
          <Row className="align-items-center hero-content-section">
            <Col lg={6} className="hero-content">
              <h1 className="hero-title">
                {slides[currentSlide].title}
              </h1>
              <p className="hero-subtitle">
                {slides[currentSlide].subtitle}
              </p>
              <div className="hero-buttons">
                <Button variant="primary" size="lg" className="me-3" onClick={() => navigate('/learning-zone')}>
                  {slides[currentSlide].buttonText} <ArrowRight className="ms-2" />
                </Button>
                <Button variant="outline-light" size="lg" onClick={() => navigate('/Signup')}>
                  Join Our Community
                </Button>
              </div>
            </Col>
            <Col lg={6} className="hero-image-container">
              <div className="hero-image-wrapper">
                <img
                  src={slides[currentSlide].feature}
                  alt="Featured Content"
                  className={`hero-image ${imgLoaded ? 'loaded' : 'loading'}`}
                  onLoad={() => setImgLoaded(true)}
                  loading="lazy"
                />
                <div className="image-overlay"></div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default HomePage;
